import React from "react";
import { Box, Grid } from "@mui/material";
import { getMeaning } from "../../utils/localization";
import JobCard from "../../components/OurNetwork/JobCard";
import GlobalVideoCard from "../../components/GlobalVideoCard";
import Heading from "../../components/Heading";
import GlobalSubHeading from "../../components/GlobalSubHeading";

const ALLJOBS = [
  {
    jobTitle: getMeaning("CARERS.ANYLSTJOB"),
    location: getMeaning("CARERS.JOBLCTON1"),
    share: getMeaning("CARERS.SHREJOB"),
    copyLink: getMeaning("CARERS.CPYLNK"),
  },
  {
    jobTitle: getMeaning("CARERS.MANAGEROB"),
    location: getMeaning("CARERS.JOBLCTON2"),
    share: getMeaning("CARERS.SHREJOB"),
    copyLink: getMeaning("CARERS.CPYLNK"),
  },
  {
    jobTitle: getMeaning("CARERS.PRTNRSHPMANAGERJOB"),
    location: getMeaning("CARERS.JOBLCTON3"),
    share: getMeaning("CARERS.SHREJOB"),
    copyLink: getMeaning("CARERS.CPYLNK"),
  },
  {
    jobTitle: getMeaning("CARERS.PRTNRSHPANYLSTJOB"),
    location: getMeaning("CARERS.JOBLCTON4"),
    share: getMeaning("CARERS.SHREJOB"),
    copyLink: getMeaning("CARERS.CPYLNK"),
  },
  {
    jobTitle: getMeaning("CARERS.PRDCTANYLSTJOB"),
    location: getMeaning("CARERS.JOBLCTON5"),
    share: getMeaning("CARERS.SHREJOB"),
    copyLink: getMeaning("CARERS.CPYLNK"),
  },
];

const Network = () => {
  return (
    <Box style={{ flex: 1, marginTop: 100 }}>
      <Box>
        <GlobalVideoCard />
      </Box>

      <Box mt={4} align="center">
        <Heading title={getMeaning("CARERS.CARERATAA")} />
        <GlobalSubHeading subTitle={getMeaning("CARERS.SBHDNG")} />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            width: 2,
            height: { xs: 50, md: 70 },
            background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
          }}
        />
      </Box>

      <Box align="center">
        <Heading title={getMeaning("CARERS.FNDJOBATAA")} />
        <GlobalSubHeading subTitle={getMeaning("CARERS.FNDJOBATAAHDNG")} />
      </Box>

      <Box mt={4} align="center">
        <Heading title={getMeaning("CARERS.ALLJOBS")} />
        <GlobalSubHeading subTitle={getMeaning("CARERS.SHOWRSLTS")} />
      </Box>

      <Grid
        container
        spacing={3}
        display="flex"
        flexDirection="row"
        justifyContent="center"
        sx={{
          // marginTop: 4,
          marginBottom: 4,
          p: 3,
        }}
      >
        {ALLJOBS?.map((item, index) => {
          return (
            <Grid item key={index} xs={12} sm={6} md={4} lg={4} xl={3}>
              <JobCard
                jobTitle={item?.jobTitle}
                location={item?.location}
                share={item?.share}
                copyLink={item?.copyLink}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Network;
